// tutorials
import BusEvent from '../../../shared/js/BusEvent';
import {RegisterOptions, VuexModule} from 'vuex-class-modules';

export class TutorialModule extends VuexModule {

    private hasSeenChooseFromThemes : boolean = false;
    private hasSeenChooseOneTheme : boolean = false;
    private hasSeenChooseBreadcrumbChooseTheme : boolean = false;
    private hasSeenChooseCreateTestimonial : boolean = false;


  constructor(options: RegisterOptions) {
    super(options);

    this.registerTutorialDisplayEvents();
  }

  private registerTutorialDisplayEvents() {


    // document.addEventListener(BusEvent.EVENTS.SHARE_TESTIMONIAL_VISIBILITY, (event) => {
    //   const ev = event as BusEvent;
    //
    //   if(!this.hasSeenChooseCreateTestimonial) {
    //
    //   }
    //
    //   console.log('Received tutorial', ev);
    // });

    //
    // document.addEventListener(BusEvent.EVENTS.SHOW_TUTORIAL_ITEM, (event) => {
    //   const ev = event as BusEvent;
    //
    //
    //   console.log('Received tutorial', ev);
    // });



  }




}
